import { icon } from '../lib/icons';
import type { RouteHandler } from '../lib/router';
import { renderPageShell } from '../lib/page-shell';

/** Stop the Clock's own mode menu — reached from "Choose Your Game" (play-menu.ts). Every mode here is the original timing duel; Stack Tower's modes live in their own menu, never mixed into this one. */
export const renderStopTheClockMenu: RouteHandler = (container, navigate) => {
  renderPageShell(container, navigate, 'play', {
    title: 'STOP THE CLOCK',
    subtitle: 'No reflexes. No aim. No build. Just your internal clock against someone else’s.',
    body: `
      <div class="play-feature-grid">
        <button class="choice-card choice-card--feature" type="button" data-nav="play/knockout">
          <span class="mode-icon mode-icon--feature">${icon('people')}</span>
          <strong>Knockout</strong>
          <small>Any size lobby, up to 50 players. Growing eliminations each round. Last one standing wins.</small>
        </button>
        <button class="choice-card choice-card--ranked" type="button" data-nav="play/ranked">
          <span class="mode-icon">${icon('practice')}</span>
          <strong>Ranked queue</strong>
          <small>Sign in, get matched automatically, rating updates after the match.</small>
        </button>
        <button class="choice-card choice-card--daily" type="button" data-nav="daily-challenge">
          <span class="mode-icon">${icon('target')}</span>
          <strong>Daily Challenge</strong>
          <small>Free, no sign-in. Same target as everyone, today.</small>
        </button>
      </div>
      <div class="play-mini-row">
        <button class="choice-mini" type="button" data-nav="play/local">
          <span class="mode-icon mode-icon--mini">${icon('bolt')}</span>
          <span><strong>Local pass-and-play</strong><small>Two players, one device.</small></span>
        </button>
        <button class="choice-mini" type="button" data-nav="play/online">
          <span class="mode-icon mode-icon--mini">${icon('layers')}</span>
          <span><strong>Custom match</strong><small>Room code, separate devices.</small></span>
        </button>
        <button class="choice-mini" type="button" data-nav="practice">
          <span class="mode-icon mode-icon--mini">${icon('settings')}</span>
          <span><strong>Practice</strong><small>Train your internal clock.</small></span>
        </button>
        <button class="choice-mini" type="button" data-nav="challenge-10s">
          <span class="mode-icon mode-icon--mini">${icon('arrow')}</span>
          <span><strong>10 Second Challenge</strong><small>Hit exactly 10.000s.</small></span>
        </button>
      </div>
    `,
  });
};
